<template>

<span>

    <Menu/>

    <Loading
      v-if="loading"
      :isLoading="loading"/>

    <CreateTaskPopup
      :task="childTask"
      @createdChild:task="childTaskCreated"
      @message:task="makeToast"
    />

    <!-- 20260507 -- Copilot (Claude Sonnet 4.6) -- ShareModal included here because TaskDetail uses Menu (not AppLayout) -->
    <ShareModal ref="shareModal" />

    <TaskTableRow
        v-if="!loading"
        :task="task"
        :childrenExpanded="true"
        :detailExpanded="true"
        @createChild:task="addChildTask"
        @message:task="makeToast"
        @delete:task="localDeleteTask"/>

</span>


</template>
<script>
import CreateTaskPopup from '@/components/CreateTaskPopup.vue'
import Loading from '@/components/Loading.vue'
import Menu from '@/components/menus/UserMenu.vue'
// 20260507 -- Copilot (Claude Sonnet 4.6) -- ShareModal included for TaskDetail (uses Menu, not AppLayout)
import ShareModal from '@/components/ShareModal.vue'
import TaskService from '../services/TaskService';
import VueMarkdown from 'vue-markdown'
import TaskTableRow from '@/components/TaskTableRow.vue'

import taskOps from '../mixins/taskOps'
	import genericOps from '../mixins/genericOps'

export default {
    name: 'TaskDetail',
    metaInfo() {
        return {
            title: 'Principal Task | Task Detail',
        }
    },
    components: {
        CreateTaskPopup,
        Loading,
        Menu,
        ShareModal,
        TaskTableRow,
        'vue-markdown': VueMarkdown
    },
    mixins: [taskOps, genericOps],
    props: {
    },
    data() {
        return {
            childTask: {},
            hideChildren: false,
            hideDetail: false,
            loading: true,
            task: {
                children: []
            },
            taskId: null,
        }
    },
    computed: {
        
    },
    watch: {
        task: function(newVal) {
        
            ////console.log('TaskDetail.watch.task has task = ' + JSON.stringify(newVal))

        },
    },
    beforeRouteUpdate (to, from, next) {
		
        // ////console.log('TaskDetail.beforeRouteUpdate: ' + JSON.stringify(to.params))
        this.taskId = to.params.taskId
        this.preparePage()
        next()
    },
    mounted() {

        // ////console.log('TaskDetail.mounted: ' + JSON.stringify(this.$route.params))
        this.taskId = this.$route.params.taskId
        // ////console.log('TaskDetail.mounted has taskId: ' + this.taskId)
        this.preparePage()
        // 20260507 -- Copilot (Claude Sonnet 4.6) -- TaskDetail uses Menu (not AppLayout), so handle share event locally
        this.$root.$on('open:shareTask', this._handleShareTask)

    },
    beforeUnmount() {
        this.$root.$off('open:shareTask', this._handleShareTask)
    },
    async created() {
        // ////console.log('TaskDetail.created')
    },
    methods: {
        addChildTask(parentTask) {
        
            //Object.assign(this.task, {})
            
            if(typeof parent !== 'undefined' && parentTask !== null) {
                this.$set(this.childTask, 'parent', parentTask._id)
                this.$set(this.childTask, 'parentTask', parentTask)
            }
            
            //////console.log('\n\nTasks.addChildTask passing localTask = ' + JSON.stringify(this.task))

            this.$bvModal.show('taskModal')
        },
        async preparePage() {
            
            this.loading = true

            let that = this
            
            if(typeof this.taskId != 'undefined' && this.taskId !== null) {
            
                try {

                    await TaskService.getTask(this.$store.getters.getUser._id, this.taskId, this.$store.getters.getUserToken).then(function(response) {

                        let resp = response.data.response

                        // ////console.log('TaskDetail has response = ' + JSON.stringify(resp))

                        // ////console.log('TaskDetail has array[0] = ' + JSON.stringify(resp.data[0]))
                        
                        try {
                            that.task = resp.data[0]
                        } catch(e) {
                            ////console.log('TaskDetail encountered an error parsing the data array = ' + e)
                        }
                        

                        //////console.log('TaskDetail has task = ' + this.task)

                    }).catch((error) => {

                        ////console.log('Error getting task: ' + JSON.stringify(error))

                    })

                } catch(e) {
                    ////console.log(e)
                }

            }
            

            this.loading = false
        },
        childTaskCreated(newTask, message) {
            
            // 20200405 -- ZWS -- Refresh the parent when a child is added.

            let that = this

            if(typeof newTask.parent != 'undefined' && newTask.parent !== null && newTask.parent.length > 0) {
                
                TaskService.getTask(this.$store.getters.getUser._id, newTask.parent, this.$store.getters.getUserToken).then(function(response) {
                
                    let resp = response.data.response

                    try {
                        that.task = resp.data[0]
                        ////console.log('taskOps.saveComplete has refreshed task = ' + JSON.stringify(that.task))
                    } catch(e) {
                        ////console.log('taskOps.saveComplete encountered an error parsing the data array = ' + e)
                    }

                }).catch((error) => {

                    ////console.log('taskOps.saveComplete encountered an error getting a task: ' + JSON.stringify(error))

                })
            }

        },
        localDeleteTask(id) {

            this.deleteTask(id)

            if(typeof this.task == 'undefined' || this.task === null) {
                ////console.log('task is null')
                this.$router.go(-1)
            } else {
                ////console.log(JSON.stringify(this.task))
            }
        },

        // 20260507 -- Copilot (Claude Sonnet 4.6) -- Open share modal from $root event (local handler for non-AppLayout context)
        _handleShareTask(task) {
            this.$refs.shareModal.open(task);
        },
    }
}

</script>

<style scoped>

</style>